export default __webpack_public_path__ + "static/media/materieprime-img.4cbd5187.png";